import React, { useContext, useEffect, useState } from 'react';
import {
  NavigationTab as Tab,
  NavigationTabGroup as TabGroup,
  ContentContainer
} from '@tmobile/tmo-bps-syncup-web-component-lib';

// Table component used to render API status details
import StatusTable from './StatusTable';

// Helper that returns API status configuration per product
import { apiStatusData } from '../../utils/apiStatusHelper';

// Context providing currently selected SyncUp product
import SyncUpProductContext from '../../context/SyncUpProductContext';

// Utility to safely check for non-empty values
import { hasValue } from 'utils/helper_functions';

// CSS module styles
import style from './StatusTable.module.css';

/**
 * API Status page
 * - Displays API groups as tabs
 * - Renders status table for the selected API group
 * - Product-aware via SyncUpProductContext
 */
const APIStatusPage = () => {
  // Access the currently selected SyncUp product (e.g., DRIVE, TRACK)
  const syncUpProductContext = useContext(SyncUpProductContext);

  // Initialize API list based on active product
  const [APIList] = useState(apiStatusData(syncUpProductContext.syncUpAppName));

  // Track the currently selected tab index
  const [tabSelected, setTabSelected] = useState(0);

  // Track the currently selected API group shown in the table
  const [selectedGroup, setSelectedGroupAPI] = useState(APIList[tabSelected]);

  /**
   * Update the selected API group whenever
   * the selected tab or API list changes
   */
  useEffect(() => {
    setSelectedGroupAPI(APIList[tabSelected]);
  }, [tabSelected, APIList]);

  return (
    <ContentContainer className={style.container}>
      {/* Tab navigation for API groups */}
      <TabGroup className={style.tabs_group} type="secondary">
        {APIList &&
          APIList.map((group, index) => (
            <Tab
              key={index}
              value={index}
              type="secondary-tab"
              text={group.name}
              isSelected={index === tabSelected}
              // Update selected tab index on click
              onSelect={val => setTabSelected(val)}
            />
          ))}
      </TabGroup>

      {/* Render status table only when categories exist */}
      {hasValue(selectedGroup.categories) && (
        <StatusTable
          name={selectedGroup.name}
          key={`selected-group-table-${selectedGroup.name}`}
          item={selectedGroup.categories}
        />
      )}
    </ContentContainer>
  );
};

export default APIStatusPage;
